import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
var AlertBlockService = /** @class */ (function () {
    function AlertBlockService() {
        this.components = [];
        this.models = {};
        this.targetComponents = [];
        this.targetModels = {};
        this._subject = new Subject();
    }
    AlertBlockService.prototype.alert = function (error, targetComponents) {
        if (targetComponents === void 0) { targetComponents = []; }
        this._subject.next(this.getMessages(error.validationError, targetComponents));
    };
    Object.defineProperty(AlertBlockService.prototype, "observable", {
        get: function () {
            return this._subject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    AlertBlockService.prototype.setMeta = function (meta) {
        this.components = meta.components || [];
        this.models = meta.models || {};
    };
    AlertBlockService.prototype.getMessages = function (validationError, targetComponents) {
        var messages = [];
        if (typeof validationError === 'undefined') {
            return messages;
        }
        if (Object.keys(this.models).length === 0) {
            for (var _i = 0, _a = Object.keys(validationError); _i < _a.length; _i++) {
                var key = _a[_i];
                messages = messages.concat(validationError[key]);
            }
        }
        else {
            this.targetComponents = [];
            this.targetModels = {};
            if (targetComponents.length > 0) {
                this.getTarget(this.components, targetComponents);
            }
            else {
                this.targetComponents = this.components;
                this.targetModels = this.models;
            }
            for (var _b = 0, _c = Object.keys(validationError); _b < _c.length; _b++) {
                var key = _c[_b];
                var component = jsonpath.value(this.targetComponents, '$..[?(@.name=="' + key + '")]');
                var item = jsonpath.value(this.targetModels, '$..[?(@.key=="' + key + '")]');
                if (!component && !item) {
                    messages = messages.concat(validationError[key]);
                }
            }
        }
        return messages;
    };
    AlertBlockService.prototype.getTarget = function (components, targetComponents) {
        for (var _i = 0, components_1 = components; _i < components_1.length; _i++) {
            var comp = components_1[_i];
            if (targetComponents.indexOf(comp.name) >= 0 && typeof comp.model !== 'undefined' && typeof this.models[comp.model] !== 'undefined') {
                this.targetModels[comp.model] = this.models[comp.model];
            }
            if (targetComponents.indexOf(comp.name) >= 0) {
                this.targetComponents.push(comp);
            }
            this.getTarget(comp.components || [], targetComponents);
        }
    };
    AlertBlockService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    AlertBlockService.ctorParameters = function () { return []; };
    return AlertBlockService;
}());
export { AlertBlockService };
//# sourceMappingURL=alertblock.service.js.map